import Comps from '@owenscorning/react-library';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import CheckBox from '../../shared/Checkbox/index';
import RadioButton from '../../shared/RadioButton/index.jsx';
import Address from '../../shared/address';
import styles from '../../shared/warranty-registration.module.scss';
import { hideModal, setFormData, incrementStep, submitClaim, propertyLookup } from '../redux/action';

const { Modal } = Comps.Connect;

const SUGGESTED = 'suggested';
const USER_ENTERED = 'user_entered';

const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

const NoSuggestionVerifier = ({ propertyOrOwner, addresses, fieldKey }) => {
  const storeFieldKey = `verified${capitalizeFirstLetter(propertyOrOwner)}`;
  const enteredAddress = addresses[fieldKey];

  return (
    <div className={styles.modalSection}>
      <h3>{`${capitalizeFirstLetter(propertyOrOwner)} Address`}</h3>
      <div className={styles.modalSection}>
        <div className={styles.radioOption}>
          <Address address={enteredAddress} />
        </div>
        <div className={styles.radioOption}>
          <CheckBox fieldKey={storeFieldKey} text="I confirm this address is correct." />
        </div>
      </div>
    </div>
  );
};

const AddressSuggestionPicker = ({ propertyOrOwner, addresses, selections, fieldKey }) => {
  const suggestionKey = `suggested${capitalizeFirstLetter(propertyOrOwner)}`;
  const suggestedAddress = addresses[suggestionKey];
  const enteredAddress = addresses[fieldKey];

  if (_.isEqual(suggestedAddress, enteredAddress)) {
    return (
      <div>
        <h3>{`${capitalizeFirstLetter(propertyOrOwner)} Address matches suggestion exactly`}</h3>
      </div>
    );
  }

  return (
    <div className={styles.modalSection}>
      <h3>{`${capitalizeFirstLetter(propertyOrOwner)} Address`}</h3>
      <div>
        <div className={styles.radioOption}>
          <RadioButton
            value={USER_ENTERED}
            checked={selections == USER_ENTERED}
            fieldKey="selections"
            htmlAttributes={{}}
          >
            <h5>Entered Address</h5>
            <Address address={enteredAddress} />
          </RadioButton>
        </div>
        <div className={styles.radioOption}>
          <RadioButton value={SUGGESTED} checked={selections == SUGGESTED} fieldKey="selections" htmlAttributes={{}}>
            <h5>Suggested Address</h5>
            <Address address={suggestedAddress} />
          </RadioButton>
        </div>
      </div>
    </div>
  );
};

const VerificationBody = props => {
  const {
    suggestedProperty,
    propertyAddress,
    newContractorInfo,
    fieldKey,
    suggestedOwner,
    ownerAddress,
    ownerAddressSameAsProperty,
  } = props;
  const { setFormData, hideModal, incrementStep, step, submitClaim, propertyLookup, selections } = props;
  const addresses = {
    suggestedProperty,
    propertyAddress,
    suggestedOwner,
    ownerAddress,
    newContractorInfo,
  };
  const continueEnabled = suggestedProperty || props.verifiedProperty;
  const [propertySelection, setPropertySelection] = useState(SUGGESTED);
  const [ownerSelection, setOwnerSelection] = useState(SUGGESTED);
  // const selections = { propertySelection, ownerSelection }

  const updateThenSaveContinue = () => {
    const update = {};
    if (suggestedProperty.street) {
      update.verifiedProperty = true;
      if (selections == SUGGESTED) {
        if (fieldKey === 'propertyAddress') {
          update.propertyAddress = suggestedProperty;
        } else {
          update.newContractorInfo = {
            firstName: newContractorInfo.firstName,
            lastName: newContractorInfo.lastName,
            company: newContractorInfo.company,
            phone: newContractorInfo.phone,
            ...suggestedProperty,
          };
        }
      }
      // propertySelection == USER_ENTERED
      else if (fieldKey === 'propertyAddress') {
        update.propertyAddress = propertyAddress;
      } else {
        update.newContractorInfo = newContractorInfo;
      }
    }
    // API doesn't return any suggested address
    else if (!suggestedProperty.street) {
      if (fieldKey === 'propertyAddress') {
        update.propertyAddress = propertyAddress;
      } else {
        update.newContractorInfo = newContractorInfo;
      }
    }
    if (suggestedOwner) {
      if (suggestedOwner.street1) {
        update.verifiedOwner = true;
        if (ownerSelection == SUGGESTED) {
          update.ownerAddress = suggestedOwner;
        }
      } else if (!suggestedOwner.street) {
        update.ownerAddress = ownerAddress;
      }
    }

    if (ownerAddressSameAsProperty) {
      update.verifiedOwner = !!suggestedProperty || props.verifiedProperty;
    }

    setFormData(update);
    hideModal();
    if (step === 2) {
      propertyLookup();
    } else if (step === 5) {
      setFormData({ showManualEntry: false });
      submitClaim();
    } else {
      incrementStep();
    }
  };

  return (
    <div>
      <h2>Please Verify Address</h2>
      <p>
        We could not verify the address entered. Please confirm the address you would like to use, or edit your entry.
      </p>

      {suggestedProperty.street && !suggestedOwner ? (
        <AddressSuggestionPicker
          propertyOrOwner="property"
          addresses={addresses}
          selections={selections}
          setSelection={setPropertySelection}
          fieldKey={fieldKey}
        />
      ) : (
        <NoSuggestionVerifier propertyOrOwner="property" addresses={addresses} fieldKey={fieldKey} />
      )}
      {ownerAddressSameAsProperty === 'false' &&
        (suggestedOwner.street ? (
          <AddressSuggestionPicker
            propertyOrOwner="owner"
            addresses={addresses}
            selections={selections}
            setSelection={setOwnerSelection}
            fieldKey={fieldKey}
          />
        ) : (
          <NoSuggestionVerifier propertyOrOwner="owner" addresses={addresses} />
        ))}
      <div className={styles.modalSection}>
        <a
          data-track="form-edit"
          data-track-form-name="Submit Claim"
          data-track-form-step={`step ${step} - verify address`}
          className="cta cta-secondary"
          onClick={hideModal}
        >
          Edit Address
        </a>
        <a
          data-track="form-advance"
          data-track-form-name="Submit Claim"
          data-track-form-step={`step ${step} - verify address`}
          className={`cta ${continueEnabled ? '' : 'disabled'}`}
          onClick={updateThenSaveContinue}
        >
          Save & Continue
        </a>
      </div>
    </div>
  );
};

const AddressVerificationModal = props => (
  <Modal onClose={props.hideModal} open={props.showModal} className={styles.addressVerificationModal}>
    <VerificationBody {...props} />
  </Modal>
);

const mapStateToProps = state => ({
  dataComplaints: state.dataComplaints,
  ownerAddress: state.formData.ownerAddress,
  ownerAddressSameAsProperty: state.formData.ownerAddressSameAsProperty,
  propertyAddress: state.formData.propertyAddress,
  newContractorInfo: state.formData.newContractorInfo,
  showModal: state.showModal,
  suggestedOwner: state.metadata.suggestedOwner,
  suggestedProperty: state.metadata.suggestedProperty,
  verifiedOwner: state.formData.verifiedOwner,
  verifiedProperty: state.formData.verifiedProperty,
  hasExistingWarranty: state.formData.hasExistingWarranty,
  selections: state.formData.selections,
  step: state.step,
});
const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal()),
  setFormData: hash => dispatch(setFormData(hash)),
  incrementStep: () => dispatch(incrementStep()),
  submitClaim: () => dispatch(submitClaim()),
  propertyLookup: () => dispatch(propertyLookup()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressVerificationModal);
